export enum HorizontalDirection {
    LEFT = -1,
    RIGHT = 1,
}

export enum VerticalDirection {
    UP = -1,
    DOWN = 1,
}
